import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

import TvSubscription from './TvSubscription';

const StyledTvSubscription = styled(TvSubscription)`
    display: block;
    
    width: 100%;
    
    img {
        max-width: 100%;
        max-height: 138px;
    }
    
    @media (min-width: ${wideBreakpoints.mobile}) {
        max-width: 304px;
    }
`;

export default StyledTvSubscription;
